import React from 'react';

import './Entry.css';
// import '../App.css';
import TwoColumn from '../components/TwoColumn.jsx'

import img from '../images/wallpaperGradient.png';
import simpplrHeaderImg from '../images/simpplrGradient.png';
import simpplrScreen from '../images/KnowledgeTab1.png';
import simpplrStickies from '../images/Stickies.png';
import simpplrLaptop from '../images/KnowledgeHiFi1.png';
import simpplrFilter from '../images/Filter1.gif';
import simpplrQuickActions from '../images/QuickActions1.gif';

function gt_simpplr(headerVar) {

    return(
         <div className='gt_simpplr'>
               <script>
               window.onload = function() {
                   document.body.style.backgroundImage = `url(${simpplrHeaderImg})`
               };
           </script>
           <script>
               window.onload = function2() {
                   document.body.style.backgroundRepeat = "no-repeat"
               };
           </script>
           <script>
                window.onload = function3() {
                window.scrollTo(0, 0)
                };
           </script>
       
       
           <e-h1>Designing a Dashboard’s Information Architecture</e-h1>
           <p> </p>
           <e-h2>UX Researcher & Designer</e-h2>
           <p> </p>

           <p>Deep and varied research methods to determine user needs in a dashboard, and full iterations of designs based on researched insights.</p>
           
           <hr class="divider1"></hr>
           <e-h2>How might we <strong>tailor</strong> the home dashboard to better support the <strong>work tasks</strong> of end users?</e-h2>
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Product: </strong> </p>
                        <p className = 'twoCol-description'>Simpplr is a white-label intranet service, meaning other companies utilize Simpplr’s platform to promote connectivity and relations across their company. This comes in the form of a news and social site, which also has integration with Jira, Google Drive, and other such platforms. The issue presented to us was the need to improve adoption and stickiness for users, or how to make the platform something users would open every day. An initial suggestion that became backed up by research was one related to improving Simpplr’s capability to help users increase productivity.
</p>
                        <p className = 'twoCol-description'>This was a project for Simpplr hosted through a Georgia Tech class. Our role here was to work with our industry partner to provide a fresh take on the issue and product. We were to follow a process of initial secondary research, active primary research, and then ideate, sketch, and prototype with rounds of feedback from users and experts in between.
</p>
                    
                </div> 
        
                <div className='twoCol-img'>
                        <img src={simpplrScreen} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>
            
            <hr class="divider1"></hr>
            <e-h2><strong>Insight: </strong> Users felt that their need of being able to see relevant information was not being met. </e-h2>
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Pre-production Research: </strong>Survey, Contextual Inquiry, Cognitive Walkthrough, Comparative Analysis (Affinity Maps, Spreadsheets)
</p>
                        <p className = 'twoCol-description'>Users often used the platform to search for files, knowledge articles, or people, as well as checking up on company news.
</p>
                        <p className = 'twoCol-description'>Users experienced a lack of visual clarity/hierarchy throughout the system.
</p>
                </div> 

                <div className='twoCol-img'>
                        <img src={simpplrStickies} alt="" className='twoCol-image' /> 
                </div>
            </TwoColumn>
            <hr class="divider2"></hr>
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Post-production Evaluation: </strong>Mid-fi User Testing
</p>
                        <p className = 'twoCol-description'>Our focus for the next iteration was on visual feedback, labelling, and descriptions. Our solutions were to pair text with iconography as much as possible, to improve visual hierarchy by changing colors and values, and add more recoverability from errors, which would equate to things like back buttons.
</p>
                    
                </div> 
        
                <div className='twoCol-img'>
                        <img src={simpplrLaptop} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>

            

            <hr class="divider1"></hr>
            <e-h2><strong>Goal: </strong>Split the main content of the current dashboard into three tabs: Home, Knowledge, and Social</e-h2>
            <p> </p>
            <p>I spearheaded the design for the Knowledge tab, and made sure to create a page that would improve upon  showing relevant information and having better readability overall.</p>
            <hr class="divider3"></hr>
            <p><strong>Filters </strong></p>
            <p>Drop-downs can allow a user to sort by various filters, and change the general layout of how blog posts are displayed. Additionally, hovering on them gives action items. 
            </p>
            <p>These also serve to allow End users to cater to and organize their own personalized relevant interests.
            </p>
            <img src={simpplrFilter} alt="" className='twoCol-image' /> 
            <hr class="divider2"></hr>
            <p><strong>Quick Actions </strong></p>
            <p>Actions are accessible when a user hovers their mouse over the blog posts in the main screen. 
            </p>
            <p>The same actions are also available at the side of the screen, as well as additional features such as screen reading or resizing text for accessibility when actively reading blog posts
            </p>
            <img src={simpplrQuickActions} alt="" className='twoCol-image' /> 

            <hr class="divider1"></hr>
            <e-h2><strong>Takeaways for the future: </strong></e-h2>
            <hr class="divider3"></hr>
            <p><strong>Further emphasize readability in iconography, fonts, and visual hierarchy.</strong></p>
            <p> </p>
            <p><strong>Spend more time on the onboarding process and overall learnability of our designs.</strong></p>
            <p> </p>
            <p><strong>Expand past the home dashboard to ensure a good balance with other Simpplr features.</strong></p>
            
            <hr class="divider3"></hr>
            <hr class="divider3"></hr>
            </div>
    )
}


export default gt_simpplr


// WEBPACK FOOTER //
// ./src/pages/gt_simpplr.jsx